/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { isIntegerDependencies } from './dependenciesIsInteger.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createApplyTransform } from '../../factoriesAny.js';
export var applyTransformDependencies = {
  isIntegerDependencies: isIntegerDependencies,
  typedDependencies: typedDependencies,
  createApplyTransform: createApplyTransform
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesApplyTransform.generated.js
// module id = 1479
// module chunks = 0